import * as React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";

export default function TypePicker({setFilterInputContainer, fieldKey,isDisabled}) {

    const [mode, setMode] = React.useState('standard');

    const handleChange = (event) => {
        setMode(event.target.value);
        setFilterInputContainer(prev => {
                return (prev.map(element => {
                    if (element.key === fieldKey) {
                        return ({...element, mode: event.target.value})
                    }
                    return (element)
                }))
            }
        )
    };

    return (
        <FormControl
            sx={{width: 450}}
        >
            <InputLabel id="demo-simple-select-label">TRYB SZUKANIA/SEARCH MODE</InputLabel>
            <Select
                disabled={isDisabled}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={mode}
                label="TRYB SZUKANIA/SEARCH MODE"
                onChange={handleChange}
            >
                <MenuItem key={1} value={'standard'}>WPISZ/ENTER</MenuItem>
                <MenuItem key={2} value={'autocomplete'}>WYBIERZ Z LISTY/SELECT FROM THE LIST</MenuItem>
            </Select>
        </FormControl>
    )
}

